import Grid from '@mui/material/Grid';

import { BootstrapAddressFields, BootstrapTextField } from '../forms';

const FORM_OPTIONS = [
	{
		id: 0,
		label: 'First Name',
		size: 6,
		required: true,
		checked: true,
		postValue: 'first_name',
		component: (
			<Grid item xs={6}>
				<BootstrapTextField
					key={0}
					id="firstname"
					label="First Name"
					placeholder="Fred"
					disabled
					inputType="text"
				/>
			</Grid>
		)
	},
	{
		id: 1,
		label: 'Last Name',
		required: true,
		checked: true,
		size: 6,
		postValue: 'last_name',
		component: (
			<Grid item xs={6}>
				<BootstrapTextField
					key={1}
					id="lastName"
					label="Last Name"
					placeholder="Johnson"
					disabled
					inputType="text"
				/>
			</Grid>
		)
	},
	{
		id: 2,
		label: 'Email',
		required: true,
		checked: true,
		size: 12,
		postValue: 'email',
		component: (
			<Grid item xs={12}>
				<BootstrapTextField
					key={2}
					id="email"
					label="Email"
					placeholder="fredjohnson@gmail.com"
					disabled
					inputType="text"
				/>
			</Grid>
		)
	},
	{
		id: 3,
		label: 'Date of Birth',
		checked: false,
		postValue: 'dob',
		size: 2,
		component: (
			<Grid item xs={4}>
				<BootstrapTextField key={3} id="password" label="Date of Birth" inputType="text" />
			</Grid>
		)
	},
	{
		id: 4,
		label: 'Phone Number',
		checked: false,
		postValue: 'phone',
		component: (
			<Grid item xs={8}>
				<BootstrapTextField key={4} id="password" label="Phone Number" inputType="text" />
			</Grid>
		)
	},
	{
		id: 5,
		label: 'Address',
		checked: false,
		postValue: 'address',
		component: <BootstrapAddressFields key={5} id="email" label="Email" inputType="text" />
	},
	{
		id: 6,
		label: 'Website',
		checked: false,
		postValue: 'website',
		component: <BootstrapTextField key={6} id="website" label="Website" inputType="text" />
	},
	{
		id: 7,
		label: 'Company',
		checked: false,
		postValue: 'company',
		component: <BootstrapTextField key={7} id="company" label="Company" inputType="text" />
	}
];

export default FORM_OPTIONS;
